// ──────────────────────────────────────
// CREATE PROJECT RESPONSE MAPPER
// ──────────────────────────────────────

import { SaveProjectResponseData } from '../../interfaces/api/responses/saveProject.response';

import { IqeProject } from '../../interfaces/ui';
import { ProjectFormData } from '../../interfaces/ui/addProjectModal';
import { toUiProjectStatus } from '../sharedDto/status.dto';

export function mapSaveProjectResponse(
  formData: ProjectFormData,
  responseData: SaveProjectResponseData,
): IqeProject {
  const newProjectId = responseData.projectId;
  const createdDate = responseData.createdAt
    ? new Date(responseData.createdAt)
    : new Date();

  const newIqeProject: IqeProject = {
    id: newProjectId,
    name: formData.projectName,
    appUrl: formData.appUrl,
    loginNotRequired: formData.loginNotRequired,
    environment: formData.environment,
    projectMappingType: formData.projectMappingType,
    mappedProject: formData.mappedProjectName,
    mappedProjectOrg: formData.mappedProjectOrg,
    testPlanId: formData.testPlanId,
    testPlanName: formData.testPlanName,
    testSuiteId: formData.testSuiteId,
    testSuiteName: formData.testSuiteName,
    existingTestPlanId: formData.existingTestPlanId,
    existingTestPlanName: formData.existingTestPlanName,
    existingTestSuiteId: formData.existingTestSuiteId,
    existingTestSuiteName: formData.existingTestSuiteName,
    flowId: formData.flowId,
    flowName: formData.flowName,
    transactionId: responseData.transactionId,
    createdAt: createdDate,
    status: toUiProjectStatus(responseData.status),
    runs: [],
  };
  return newIqeProject;
}
